module.exports = __webpack_public_path__ + "img/3-mob.5381c788.svg";